import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect } from 'react';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import { isMobile } from 'react-device-detect'
import BtnWhiteBlackBorderBigSize from '../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../../Config';
import { connect } from 'react-redux';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { dwhGeneralReport, DWHStatus, DwhActionType, DWHMessageText } from '../Reports/dwhReports'
import { dwhGeneralReport as dwhCustomerGeneralReport, DwhActionType as DwhCustomerActionType, DWHMessageText as DWHCustomerMessageText } from '../../OwnershipTransferCustomerBlock/Reports/dwhReports'
import { replacePlaceholders } from '../../../../utilities/StringHelpers/TitleHelpers';

const GeneralMessage = ({ messageData, buttonClick, secondButtonClick, linkButtonClick, data, userDetails, portalsBlock }) => {
  const { icon, title, titleJet, secondTitle, secondTitleJet, buttonText, redirectPath, buttonColor, secondButtonText, linkButtonText, report } = messageData;

  const messageTitle = data.jetConnection && titleJet?.trim() ? titleJet : title;
  const messageSecondTitle = data.jetConnection && secondTitleJet?.trim() ? secondTitleJet : secondTitle;

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      dwhReportOnLoad()
    }
  }, []);

  function dwhReportOnLoad() {
    if (report) {
      switch (report) {
        case 'generalError':
          dwhGeneralReport({
            data: { ...data, userDetails: userDetails, portalsBlock: portalsBlock },
            actionType: DwhActionType.ErrorScreen,
            messageText: DWHMessageText.GeneralError,
            status: DWHStatus.Error,
          });
          break;
        case 'customerErrorSubStatus':
          dwhCustomerGeneralReport({
            data: { ...data, userDetails: userDetails },
            actionType: DwhCustomerActionType.ErrorLineOwnerPostponed,
            messageText: DWHCustomerMessageText.ErrorLineOwnerPostponedDisplayed,
            status: DWHStatus.Error
          });
          break;
        case 'customerErrorNPStatus':
          dwhCustomerGeneralReport({
            data: { ...data, userDetails: userDetails },
            actionType: DwhCustomerActionType.ErrorLineOwnerBNIYOD,
            messageText: DWHCustomerMessageText.ErrorLineOwnerBNIYODDisplayed,
            status: DWHStatus.Error
          });
          break;
        case 'linkExpired':
          dwhCustomerGeneralReport({
            data: { ...data, userDetails: userDetails },
            actionType: DwhCustomerActionType.ErrorLinkIsNotValid,
            messageText: DWHCustomerMessageText.ErrorLinkIsNotValidDisplayed,
            status: DWHStatus.Error
          });
          break;
        case 'customerAbroadError':
          dwhCustomerGeneralReport({
            data: { ...data, userDetails: userDetails },
            actionType: DwhCustomerActionType.ErrorLineOwnerIsAbroad,
            messageText: DWHCustomerMessageText.ErrorLineOwnerIsAbroadDisplayed,
            status: DWHStatus.Error
          });
          break;
        case 'formSendSuccess':
          dwhCustomerGeneralReport({
            data: { ...data, userDetails: userDetails },
            actionType: DwhCustomerActionType.SuccessScreen,
            messageText: DWHCustomerMessageText.SuccessScreenCellcomDO,
            status: DWHStatus.Completed
          });
          break;
        case 'ownershipTransferSuccess':
          dwhCustomerGeneralReport({
            data: { ...data, userDetails: userDetails },
            actionType: DwhCustomerActionType.SuccessScreen,
            messageText: DWHCustomerMessageText.SuccessScreen,
            status: DWHStatus.Completed
          });
          break;
        case 'customerGeneralError':
          dwhCustomerGeneralReport({
            data: { ...data, userDetails: userDetails },
            actionType: DwhCustomerActionType.ErrorScreen,
            messageText: DWHCustomerMessageText.GeneralError,
            status: DWHStatus.Error
          });
          break;
        default:
          break;
      }
    }
  }

  const handleSubmit = (buttonAction) => {
    if (buttonAction) {
      buttonAction();
    } else if (redirectPath) {
      EpiContext.navigateTo(redirectUrl());
    }
  };

  const redirectUrl = () => {
    switch (redirectPath) {
      case 'businessLobby':
        return Config.businessLobbyUrl;
      default:
        return redirectPath;
    }
  };

  const contentMsg = () => {
    return (
      <div className='stepContainer ownership-transfer-step'>
        <Image src={icon} />
        <p className='l-title' dangerouslySetInnerHTML={{ __html: replacePlaceholders(messageTitle, data, isMobile) }} />
        {messageSecondTitle && <p className='m-title' dangerouslySetInnerHTML={{ __html: replacePlaceholders(messageSecondTitle, data, isMobile) }} />}
        <div className='continue-button'>
          {buttonText && (
            <BtnSubmit className={buttonColor ? buttonColor : ''} text={buttonText} onclick={() => handleSubmit(buttonClick)} />
          )}
          {secondButtonText && (
            <BtnWhiteBlackBorderBigSize
              className={`${buttonColor ? buttonColor : ''} second-button`}
              text={secondButtonText}
              onclick={() => handleSubmit(secondButtonClick)}
            />
          )}
        </div>
      </div>
    );
  };

  return <div className='messagePage'>{contentMsg()}</div>;
};

const mapStateToProps = (state) => ({
  portalsBlock: state.portalsBlock,
  userDetails: state.authentication?.loginData?.userDetails,
});

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(GeneralMessage);
